import {
  SITE_LISTING,
  SITE_FILTERS,
  VIEW_DETAILS,
  ASSIGNEE_LIST,
  SITE_ENABLE_DISABLE,
  SITE_PM_STATE_LIST,
  CONTRACT_DATA_FOR_RENEWAL,
  RENEWAL_LIST,
  RENEWAL_BA_LISTING,
  HOTO_ASSIGNEE_LIST,
  BUSINESS_LIST,
  PLAN_LIST,
  FETCH_FILE_PLAN_UPLOAD,
  FETCH_INVOICE_DETAILS,
  SAVE_RENEWAL_CONTRACT
  
} from "./type";

const initalState = {
  siteListData: {},
  siteFiltersData: null,
  viewDetails: null,
  assigneeList: [],
  siteEnableDisable:{},
  sitePmStateList: {},
  contractDataForRenewal: {},
  renewalList: {},
  renewalBaListing: {},
  hotoAssigneeList: {},
  businessListing:[],
  planListingData:[],
  filePlanUploadData:[],
  installationDateChangeListing:[],
  installationDateChangeRequest:{},
  installationDateChangeApprove:{},
  renewalSaveResp:[],
  getInvoiceData:[]
};

const baSiteListingReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_LISTING:
      return {
        ...state,
        siteListData: payload,
      };
    case SITE_FILTERS:
      return {
        ...state,
        siteFiltersData: payload,
      };
    case VIEW_DETAILS:
      return {
        ...state,
        viewDetails: payload,
      };
    case ASSIGNEE_LIST:
      return {
        ...state,
        assigneeList: payload,
      };
    case SITE_ENABLE_DISABLE:
      return {
        ...state,
        siteEnableDisable: payload,
      };
    case SITE_PM_STATE_LIST:
      return {
        ...state,
        sitePmStateList: payload,
      };
    case CONTRACT_DATA_FOR_RENEWAL:
      return {
        ...state,
        contractDataForRenewal: payload
      };
    case RENEWAL_LIST:
      return {
        ...state,
        renewalList: payload
      }
    case RENEWAL_BA_LISTING:
      return {
        ...state,
        renewalBaListing: payload
      }
    case HOTO_ASSIGNEE_LIST:
      return {
        ...state,
        hotoAssigneeList: payload
      }
    case BUSINESS_LIST:
      return {
        ...state,
        businessListing: payload
      }
    case PLAN_LIST:
      return {
        ...state,
        planListingData: payload
      }  
    case FETCH_FILE_PLAN_UPLOAD:
       return {
        ...state,
        filePlanUploadData: payload
       }
    case FETCH_INVOICE_DETAILS:
        return {
         ...state,
         getInvoiceData: payload
        }
    case SAVE_RENEWAL_CONTRACT:
      return {
       ...state,
        renewalSaveResp: payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default baSiteListingReducer;
